import React from 'react';

const PageTitleSearch = () => {
    return (
            <div id="page-title" className="page-title-ml">
                <div className="wrapper">
                    <div className="title">
                        <h1 className="large">Search results for: <span className="text-primary">The</span></h1>
                    </div>

                    <div className="title-opacity">
                        <div className="title-opacity-text">Search</div>
                    </div>
                </div>
            </div>
    );
};

export default PageTitleSearch;
